import React from 'react';
import PropTypes from 'prop-types';

import SkeletonBlock from 'Components/Skeleton/SkeletonBlock';

// BlogPostsCard, or the pinned post's card above them
const Card = ({ className }) => (
  <div className={`${className} mb-3`}>
    <div className="BlogHomePageSkeleton__card">
      <div className="responsive-image responsive-image--16by9 BlogHomePageSkeleton__img" />
      <div className="p-3">
        <SkeletonBlock className="BlogHomePageSkeleton__cardTitle mb-3" />
        <SkeletonBlock className="BlogHomePageSkeleton__cardText" />
      </div>
    </div>
  </div>
);

Card.propTypes = {
  className: PropTypes.string.isRequired,
};

/**
 * Blog home, category and author listings while they load: BlogHomePage's categories, search, and BlogHomeView's
 * pinned post and post cards, with the sidebar on desktop. The banner (only on /en/blog) isn't included.
 * No slots.
 */
export default function BlogHomePageSkeleton() {
  return (
    <div className="BlogHomePageSkeleton">
      <div className="container">
        <SkeletonBlock className="BlogHomePageSkeleton__categories" />
        <SkeletonBlock className="BlogHomePageSkeleton__blurb" />
        <SkeletonBlock className="BlogHomePageSkeleton__search" />

        <div className="row mt-4">
          <div className="col-12 col-lg-8">
            <div className="row">
              <Card className="col-12" />
              <Card className="col-12 col-md-6" />
              <Card className="col-12 col-md-6" />
            </div>
          </div>

          <div className="col-lg-4 d-none d-lg-block">
            <SkeletonBlock className="BlogHomePageSkeleton__aside" />
          </div>
        </div>
      </div>
    </div>
  );
}
